<h1 mat-dialog-title>Choose a Nonbillable Absence or Attendance</h1>

<mat-dialog-content class="!pb-0">
  <div class="flex flex-row justify-between">
    <div class="w-1/2">
      <h3 id="nonbilalble-title-absence" class="mb-2 text-center text-xl font-bold">Absence</h3>
      @if (shouldShowAbsences) {
        <bar-select
          class="nonbillable-type-column"
          itemName="Nonbillable Absence Types"
          aria-labelledby="nonbilalble-title-absence"
          [items]="absence"
          (itemChosen)="select($event)"
        />
      } @else {
        <p class="text-center text-gray-500">Not available on a non-scheduled workday</p>
      }
    </div>
    <div class="w-1/2 border-l-2 border-l-[lightgray]">
      <h3 id="nonbilalble-title-attendance" class="mb-2 text-center text-xl font-bold">Attendance</h3>
      <bar-select
        class="nonbillable-type-column"
        itemName="Nonbillable Attendance Types"
        aria-labelledby="nonbilalble-title-attendance"
        [items]="attendance"
        (itemChosen)="select($event)"
      />
    </div>
  </div>
</mat-dialog-content>
